import { useGlobalContextStore } from './global-context/global-context-store';
import { useShowStore } from './show/show-store';
import { useTrackStore } from './track/track-store';
import { useUserStore } from './user/user-store';

export const useInitialLoadingInProgress = () => {
  const shows = useShowStore((s) => s.loading.initial);
  const user = useUserStore((s) => s.loading.initial);
  const track = useTrackStore((s) => s.loading.initial);
  const globalContext = useGlobalContextStore((s) => s.loading.initial);

  return shows || user || track || globalContext;
};
